import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const useStyles = makeStyles(
  {
    childrenContainer: {
      display: "inline-block",
      position: "relative"
    },
    tooltip: {
      borderRadius: "10px",
      color: "white",
      fontSize: "0.875rem",
      padding: "0.5rem 0.75rem",
      pointerEvents: "none",
      position: "absolute",
      transition: "opacity 0.2s ease-in-out",
      width: 200,
      zIndex: 9999
    },
    tooltipArrow: {
      borderBottom: "7px solid transparent",
      borderLeft: "13px solid",
      borderRadius: "3px",
      borderTop: "7px solid transparent",
      height: 0,
      position: "absolute",
      right: "-5px",
      top: "50%",
      width: 0
    }
  },
  { name: "CustomTooltip" }
);

interface CustomTooltipProps {
  text: string;
  bgColor?: string;
  width?: number;
  children: React.ReactNode;
}

const CustomTooltip: React.FC<CustomTooltipProps> = props => {
  const { text, bgColor = "black", width = 200, children } = props;
  const classes = useStyles({});
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ left: 0, top: 0 });
  const triggerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!visible || !triggerRef.current) {
      return;
    }

    const rect = triggerRef.current.getBoundingClientRect();
    setPosition({
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY + rect.height / 2
    });
  }, [visible]);

  return (
    <>
      <div
        ref={triggerRef}
        className={classes.childrenContainer}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>
      {visible &&
        ReactDOM.createPortal(
          <div
            className={classes.tooltip}
            style={{
              backgroundColor: bgColor,
              left: position.left,
              top: position.top,
              transform: "translate(-100%, -50%)",
              width
            }}
          >
            {text}
            <div
              className={classes.tooltipArrow}
              style={{
                backgroundColor: bgColor,
                borderRightColor: bgColor,
                color: bgColor,
                transform: "translateY(-50%)rotate(45deg)"
              }}
            />
          </div>,
          document.body
        )}
    </>
  );
};

CustomTooltip.displayName = "CustomTooltip";
export default CustomTooltip;
